<template>
  <div class="broadcastoto infoPub">
    <el-col class="infoPub" style="width: 990px">
      <!-- 搜索组件 -->
      <search-bar
        ref="serarchBar"
        :selectType="ExhIndexType"
        :searchInputPlc="language.studioFairName"
        :searchSelectPlc="language.exhibitionState"
        @changeExhibitionState="toSearch"
        :broadcastTrue="true"
        :userInfoId="userInfo.user_id"
        @toSearch="toSearch"
      ></search-bar>
      <!--提示信息-->
      <div class="prompt-info-wrap">
        <div
          class="prompt-info"
          v-if="lan == 'ch'"

        >
          1、请点击“我要布展”，完善您的展位信息，以便应聘者与您洽谈。
          <el-button
            type="primary"
            @click="boothProcess"
            style="float: right;margin-top: -15px;"
            class="bz"
          >
            布展流程
          </el-button>
        </div>
        <div class="prompt-info" v-if="lan == 'ch'">
          2、参展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。
        </div>
        <div class="prompt-info" v-if="lan == 'ch'">
          3、参展时，请使用谷歌浏览器打开展会官网，如需安装，<span
            class="download"
            @click="download"
          >
            {{ language.down }}
          </span>
        </div>
<!--        <div-->
<!--          class="prompt-info"-->
<!--          v-if="lan == 'ch'"-->
<!--        >-->
<!--          &lt;!&ndash; 4、您购买的展位限时优惠，额外赠送3个展位，使用前请先点击显示按钮后即可使用。 &ndash;&gt;-->
<!--        </div>-->
<!--        <div-->
<!--          class="prompt-info"-->
<!--          v-if="lan == 'en'"-->
<!--          style="padding-top:15px;margin-top:10px;"-->
<!--        >-->
<!--          Please make sure your facilities for meeting are ready before meeting start.-->
<!--          <el-button-->
<!--            type="primary"-->
<!--            @click="boothProcess"-->
<!--            style="float: right;margin-top: -15px;"-->
<!--          >-->
<!--            Booth Process-->
<!--          </el-button>-->
<!--        </div>-->
<!--        <div class="prompt-info" v-if="lan == 'en'">-->
<!--          1.Your laptop or computer with camera, headset and microphone.-->

<!--        </div>-->
<!--        <div class="prompt-info" v-if="lan == 'en'">-->
<!--          2.Using latest version of Google Chrome browser.<span-->
<!--            class="download"-->
<!--            @click="download"-->
<!--          >-->
<!--            Click to download Chrome.-->
<!--          </span>-->
<!--        </div>-->
        <!-- <div
          class="prompt-info"
          style="padding-bottom:15px;"
          v-if="lan == 'en'"
        >
          3.If you need more studio booths, please contact the administrator at overseas@wiffaorg.net.
        </div> -->
      </div>
      <!--展会标题列表-->

      <!-- <div style="height:auto; overflow:auto; padding:20px;line-height:20px;">
        <el-badge
          :value="item.BroadCount"
          class="item"
          v-for="(item, i) in exh_list"
          :key="i"
        >
          <el-button
            style="float:left"
            v-if="exhibition_id == item.exhibition_id"
            type="primary"
            >{{ lan=='ch'?item.exh_name:item.exh_name_en }}</el-button
          >
          <el-button
            style="float:left"
            v-else
            @click="exhChange(item.exhibition_id)"
            >{{ lan=='ch'?item.exh_name:item.exh_name_en }}</el-button
          >
        </el-badge>
      </div> -->

      <!-- 列表组件 -->
      <!-- @selectContact="selectContact" -->
      <oto-list
        :listData="cloneListData"
        @changData="handleBeh"
        @seatManagement="seatManagement"
        @joinData="joinData"
        @showImg="showImg"
        @showBroadcast="showBroadcast"
        v-loading="loading"
        :language="language"
        :perfectMess="perfectMess"
        :ExhIndexType="ExhIndexType"
      ></oto-list>
      <!-- page -->
      <table-page
        :pageSize="pageSize"
        :layout="layout"
        :pageTotal="pageTotal"
        :currentPage="currentPage"
        @pageChange="pageChange"
      ></table-page>
    </el-col>
    <!-- 修改弹窗 -->
    <!-----------------------我要布展-------------------------->
    <dialog-pub
      ref="dialogChild"
      class="dislogCon"
      exTop="8vh"
      :title="title"
      diaWidth="600px"
      :dialogFormVisible="dialogFormVisible"
    >
<!--      <div-->
<!--        class="prompt-info"-->
<!--        v-if="lan == 'ch'"-->
<!--        style="padding-left:0;margin-bottom:10px;"-->
<!--      >-->
<!--        请完善您的英文信息，方便海外对接。-->
<!--      </div>-->
      <div class="companyIntro">
        <div class="left">
          <img
              v-if="userInfo.company_logo_url"
              :src="userInfo.company_logo_url+'?imageMogr2/thumbnail/130x130'"
              style="object-fit: cover;"
              class="broadcast_logo"
          />
          <img
              v-else
              src="../../../assets/img_default_logo.png"
              class="broadcast_logo"
              style="object-fit: cover;"
          />
        </div>
        <div class="right">
          <div style="font-size: 18px;color: #333333;text-align: left;width: 400px;font-weight: bold;">{{userInfo.company}}</div>
          <!--公司介绍-->

          <div style="font-size: 14px;color: #666666;text-align: left;margin-top: 15px;height: 35px;word-wrap:break-word;word-break:normal;overflow: hidden;margin-right: 20px;text-overflow: ellipsis;
          display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;text-indent:25px;width: 430px;">{{userInfo.company_desc}}</div>
          <el-button style="position: absolute;right: 20px;
                        background: #2b6ff9;color: #FFFFFF;padding: 0px 10px;
                        line-height: 26px;position: absolute;top:90px;"
                     v-if="!this.perfectMess"
                     @click="showUserEdit"
            >编辑信息</el-button>
        </div>
      </div>
      <div class="wanShanXX" v-if="this.perfectMess">
        <span>您的公司信息还未为完善，无法进行布展</span>
        <el-button type="warning"
                   style="line-height: 26px;background-color: #f47900;
                   font-size: 14px;padding: 1px 10px;position: relative;left: 136px;"
                   @click="showUserEdit"
        >完善信息</el-button>
      </div>
      <el-form ref="broadcastForm" label-width="100px" class="broadcast-edit-form" :model="form" :rules="broadcastRules">
        <el-form-item
          label="招聘岗位：" prop="job_names"
          style="margin-bottom: 15px;"
        >
          <el-checkbox-group v-model="form.job_names" style="width: 420px;overflow: hidden;">
            <div v-for="(item, index) in userJobList" style="float: left;">

<!--              :label="item.jobc_super_name + '•' + item.name"-->
            <el-checkbox
                :label="item.jobc_super_name + '•' + item.name"
                style="margin-right: 8px;"></el-checkbox><span class="edit-job" @click="showEditJob(item)">(去编辑)</span>
              </div>
          </el-checkbox-group>
<!--          <span v-if="userJobList.length <= 0">您还没有添加招聘岗位，无法进行布展</span>-->
          <el-button style="position: absolute;right: 0px;top: 0px;background: #2b6ff9;color: #FFFFFF;padding: 0px 10px;line-height: 26px;"
            v-if="userJobList.length > 0"
            @click="showAddJob">添加岗位</el-button>

          <div class="no-job" v-if="userJobList.length <= 0">
            <span>您还没有添加招聘岗位，无法进行布展</span>
            <el-button type="warning"
                       style="line-height: 26px;background-color: #f47900;
                   font-size: 14px;padding: 1px 10px;position: relative;left: 145px;"
                       @click="showAddJob"
            >添加岗位</el-button>
          </div>

        </el-form-item>
        <el-form-item
          prop="broadcast_name"
          label="直播间名称："
          class="mess-item"
        >
          <el-input
            style="width:98%;"
            v-model="form.broadcast_name"
            autocomplete="off"
          ></el-input>

        </el-form-item>

        <el-form-item  prop="truename" label="面试官姓名：">
          <el-input style="width:98%" v-model="form.truename" autocomplete="off"></el-input>
        </el-form-item>


       <el-form-item  prop="user_post" label="面试官职位：" >
          <el-input style="width:98%" v-model="form.user_post" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item prop="broadcast_contact" label="邮箱：">
          <el-input style="width:98%" v-model="form.broadcast_contact" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item
          prop="broadcast_logo"
          label="直播间logo："

        >
          <el-upload
            :action="fileUpload"
            class="uploadImg"
            list-type="picture-card"
            :on-success="updateSuccess"
            :before-upload="onBeforeUpload"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            :headers="uploadHeaders"
            :limit="1"
            :file-list="imgList"
            style="margin-left:0"
            accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
          >
            <div class="upText">
              <div>{{ language.click }}</div>
              <div>{{ language.uploadLogo }}</div>
            </div>
          </el-upload>
          <div style="font-size:12px;color:#424242;padding-left:2px">
            {{ language.suggestSize }}160*160px
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <!-- <el-button class="formBtn" @click.native="ok">{{language.confirm}}</el-button> -->
        <el-button class="formBtn submitBtn" @click.native="ok" style="">{{
          language.submit
        }}</el-button>
        <el-button class="formBtn cancelBtn" type="primary" @click.native="cancel" style="background-color: #eff0f1;color: #333333;">{{
          language.cancel
        }}</el-button>
      </div>
      <div style="height: 50px;"></div>
    </dialog-pub>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="form.broadcast_logo" alt />
    </el-dialog>

    <!-- 邀请码分享 -->
    <el-dialog
      title=""
      :visible.sync="showImgDialogFormVisible"
      width="1200px"
      top="10vh"
      class="dislogCon-Img"
      style="margin: 0 auto;text-align:center;"
    >
      <!-- <img :src="imgSrc" alt="" style="margin: 0 auto;text-align:center;"> -->
      <div class="img-wrap">
        <div class="img-wrap-left">
          <img class="choose-img" :src="imgSrcList[imgSrcIndex]" alt="" />
        </div>
        <div class="img-wrap-right">
          <div class="img-wrap-title">
            <p>制作手机海报分享</p>
            <div class="div-border-bottom-color"></div>
          </div>
          <div class="img-wrap-right-top">
            <div
              :class="
                imgSrcIndex == index
                  ? 'img-wrap-right-top-div img-wrap-right-top-div-active'
                  : 'img-wrap-right-top-div'
              "
              v-for="(item, index) in imgSrcList"
              :key="index"
            >
              <img :src="item" alt="" @click="changeImgSrc(index)" />
              <img
                v-if="imgSrcIndex == index"
                class="img-right"
                src="../../../assets/icon-right.png"
                alt=""
              />
            </div>
          </div>
          <div class="img-formBtn">
            <el-button class="img-down-formBtn" @click.native="imgDown"
              >下载</el-button
            >
            <el-button
              class="img-camcale-formBtn"
              type="primary"
              @click.native="cancelImg"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 布展流程 -->
    <el-dialog
      :title="lan == 'ch'?'布展流程':'Booth Process'"
      :visible.sync="showBoothProcess"
      width="702px"
      top="10vh"
      class="dislogCon-Img"
      style="margin: 0 auto;text-align:center;"
    >
      <div class="boothProcessContent" v-if="lan == 'ch'">
        <div style="height: 1px;background-color: #dddddd;"></div>
        <div class="boothProcessTitle">1、填写布展信息</div>
        <img src="../../../assets/img/booth/one.png" />
<!--        <img src="../../../assets/booth/booth_cn_1_2.jpg" />-->
        <div class="boothProcessTitle">2、分配坐席</div>
        <img src="../../../assets/img/booth/two.png" />
        <img src="../../../assets/img/booth/three.png" />
        <div class="boothProcessTitle">3、检查设备</div>
        <img src="../../../assets/img/booth/four.png" />
        <img src="../../../assets/img/booth/five.png" />
      </div>
      <div class="boothProcessContent" v-if="lan == 'en'">
        <div style="height: 1px;background-color: #dddddd;"></div>
        <div class="boothProcessTitle">1、Fill in information</div>
        <img src="../../../assets/booth/booth_en_1_1.png" />
        <img src="../../../assets/booth/booth_en_1_2.png" />
        <div class="boothProcessTitle">2、Allocation of seats</div>
        <img src="../../../assets/booth/booth_en_2_1.png" />
        <img src="../../../assets/booth/booth_en_2_2.png" />
        <div class="boothProcessTitle">3、Check equipment</div>
        <img src="../../../assets/booth/booth_en_3_1.png" />
        <img src="../../../assets/booth/booth_en_3_2.png" />
      </div>
    </el-dialog>
    <!--席位管理-->
    <el-dialog
      :visible.sync="showSeatManagement"
      width="1108px"
      top="10vh"
      class="dislogCon-Img seatManagement"
      style="margin: 0 auto;text-align:center;"
    >
      <div class="place-manage">席位管理</div>
      <div class="seatManagementContent">
        <ticketsExhibition ref="ticketsExhibition" :broadcast_id="broadcast_id"/>
      </div>
    </el-dialog>
    <line-dialog
      :show.sync="visibleLine"
      :lan="language"
      :waitData="waitData"
      :lanState="lan"
    />
    <download-dialog :show.sync="downloadShow" />
    <edit-job ref="editJob" @saveEvent="saveEvent"></edit-job>
    <edit-user-info ref="editUserInfo" @userSaveEvent="userSaveEvent"></edit-user-info>
  </div>
</template>
<script>
import reqest from "@/common/reqest";
import { language } from "../../../language/get";
import searchBar from "../components/searchbar/searchbar";
import otoList from "../components/otolist/otolist";
import tablePage from "../components/tablepage/tablepage";
import dialogPub from "../components/dialogpub/dialogpub";
import { getLiveUrl, selectContact } from "../../../api/forum";
import { mapGetters } from "vuex";
const pubLanguage = language();
import { ExhIndexType } from "../../../common/constant/exhibition";
import Cookie from "../../../common/cookie";
import downloadDialog from "../../../components/DownloadDialog/index";
import editJob from "@/pages/user/attendancerecord/editJob";
import editUserInfo from "@/pages/user/userinfo/editUserInfo";
import {
  getBroadcastList,
  findUserJogList,
  editBroadcastList,
  toggleBroadcast,
  getMyBroadcastList,
  getMyExhibition
} from "../../../api/btManage";
import {
  exhibitionEnterLiveRoom,
  getUserLiveRoom,
  getAllExhibition,
} from "@/api/newRequest";
import { isEmpty, isInternet } from "../../../common/validate";
import { goRoom } from "../../../api/webSocket";
import lineDialog from "../../../components/LineDialog";
import { roomUrl, windowsGoTo } from "../../../common/url";
import axios from "axios";
import {MessageBox} from 'element-ui';

import ticketsExhibition from '../ticketsExhibition/ticketsExhibition'
import {getUserInfo} from "@/api/user";

export default {
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  components: {
    editUserInfo,
    searchBar,
    editJob,
    otoList,
    tablePage,
    dialogPub,
    lineDialog,
    downloadDialog,
    ticketsExhibition,
  },
  data() {
    return {
      oldItem:"",
      tipJob:null,
      showBoothProcess: false,
      showSeatManagement: false,
      uploadHeaders: {token: localStorage.getItem("token")},
      fileUpload: reqest.apiUrl+'/Home/Publicother/uplodadLogo',
      exhibition_id: 0,
      loading: false,
      perfectMess:null, //是否完善信息
      getJobId:null, // 搜索的招聘会ID
      keyword:null, // 搜索招聘会的名字
      ExhIndexType,
      userId:null,
      //弹窗
      title: pubLanguage.editeStudio1,
      //图片上传
      dialogVisible: false,
      imgList: [],
      subscribeStartTimes: [],//预约开始时间
      subscribeEndTimes: [],//预约结束时间
      dialogFormVisible: false,
      broadcastRules:{
          job_names: [
            { required: true, message: "请选择招聘岗位", trigger: 'change' }
          ],
          broadcast_name: [
            { required: true, message: "请输入直播间名称", trigger: 'change' }
          ],
          user_post: [
            { required: true, message: "请输入面试官职位", trigger: 'change'}
          ],
          truename: [
            { required: true, message: "请输入面试官姓名", trigger: 'change'}
          ],
          broadcast_contact: [
            { required: true, message: "请输入邮箱", trigger: 'change'}
          ],
          broadcast_logo: [
            { required: true, message: "请选择直播间logo", trigger: 'change'}
          ]

      },
      form: {
        job_names: "",
        user_post: "",
        broadcast_contact: "",
        broadcast_name: "",
        truename: "",
        broadcast_logo: "",
      },
      logoLabelWidth:"33%",
      language: language(),
      lan: Cookie.get("lang"),
      broadClass: [],
      listData: [],
      cloneListData: [],
      //page
      pageTotal: 0,
      pageSize: 4,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索条件
      getStateCon: null,
      getValCon: null,
      //排队
      visibleLine: false,
      waitData: {},
      downloadShow: false,

      exh_list: [],
      userJobList: [],
      imgSrcList: [],
      imgSrcIndex: 0,
      showImgDialogFormVisible: false,
      broadcast_id: ''
    };
  },
  created() {
    this.broadcastClass();
    this.getSubscribeTime();
    this.getList();
    this.tipsPerfect();
  },
  mounted() {},
  methods: {
    showUserEdit(){
      if(this.userInfo.superioruser_id != 0) {
        const height = document.body.clientHeight / 2;
        this.$message.error({message:"联系企业负责人修改" , offset:height})
      }else {
        this.$refs.editUserInfo.redactPop();
      }

    },
    userSaveEvent(uinfo){
      this.userInfo = uinfo;
    },
    saveEvent(data){
      this.broadcastClass();
    },
    showAddJob() {

        this.$refs.editJob.add();

    },
    showEditJob(item) {
        this.$refs.editJob.editJbo(item);
    },
    seatManagement(item){
      let _this = this;
      this.showSeatManagement = true;
      _this.broadcast_id = item.broadcast_id;
      setTimeout(function(){
        _this.$refs.ticketsExhibition.toSearch('', '');
      }, 100)
    },
    getSubscribeTime(){
      let times = [];
      let hh = -1;
      let mm;
      for (let i = 0; i < 48; i++) {
        if(i % 2 == 0){
          hh++;
          mm = '00';
        }else{
          mm = '30';
        }
        times.push((hh >= 10 ? hh : '0' + hh)+':'+mm)
      }
      this.subscribeStartTimes = times;
      this.form.subscribe_start = times[0];
      this.setSubscribeEndTime(times[0]);
    },
    setSubscribeEndTime(start){
      start = Number(start.replace(':',''));
      let startTime = this.subscribeStartTimes;
      let times = [];
      for (let i = 0; i < startTime.length; i++) {
        if(Number(startTime[i].replace(':','')) > start){
          times.push(startTime[i]);
        }
      }
      times.push('23:59');
      this.subscribeEndTimes = times;
      this.form.subscribe_end = times[0];
    },
    subscribeStartChange(item){
      this.setSubscribeEndTime(item);
    },
    getContentWrapHeight() {
      this.$nextTick(() => {
        // padding-top: -2px;margin-top: -5px;
        // let contentWrapHeight = this.$refs.form_index.offsetHeight;
        // let bgListLength = Math.ceil(contentWrapHeight / 400);
        // this.bgList.length = bgListLength;
        // console.log(this.bgList);
        // document.querySelectorAll(".footerBottom")[0].style.paddingTop ="-2px";
        // console.log(document.querySelectorAll(".footerBottom")[0]);
        // this.$forceUpdate()
      });
    },
    getExhibition() {
      //获取所有展会
      return getMyExhibition({user_id: this.userInfo.user_id, lan: this.lan});
      // return getAllExhibition(`/user_exhibition/${this.lan}`);
      // return axios.get("http://192.168.1.203:8080/user_exhibition/" + this.lan);
    },
    //update
    onBeforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 2;
      const height = document.body.clientHeight / 2;
      if (!isLt1M) {
        this.$message({
          showClose: true,
          message: this.language.fileMaxSize,
          type: "error",
          offset: height,
        });
      }

      return isLt1M;
    },
    updateSuccess(res) {
      if (res.type == "1") {
        this.form.broadcast_logo = res.data.file.picurl;
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    handleRemove() {
      this.form.broadcast_logo = "";
    },
    handlePictureCardPreview(file) {
      this.form.broadcast_logo = file.url;
      this.dialogVisible = true;
    },
    //是否完善信息
    tipsPerfect() {
      if(this.userInfo.company == null || this.userInfo.location == null || this.userInfo.credit_code == null ||
          this.userInfo.business_license == null || this.userInfo.true_name == null || this.userInfo.user_post == null ||
          this.userInfo.tel == null || this.userInfo.company_desc == null || this.userInfo.company_logo_url == null ||
          this.userInfo.company == "" || this.userInfo.location == "" || this.userInfo.credit_code == "" ||
          this.userInfo.business_license == "" || this.userInfo.true_name == "" || this.userInfo.user_post == "" ||
          this.userInfo.tel == "" || this.userInfo.company_desc == "" || this.userInfo.company_logo_url == ""){
        this.perfectMess = true;
      }
    },
    //修改赋值
    handleBeh(state, id, item) {
      this.oldItem = item;
      // console.log(item, 'itemitemitemitemitemitemitem')
      // console.log(item)
      if (state == 1) {
        this.exhibition_id = item.exhibition_id;
        this.$refs.dialogChild.receiveDialogFormVisible = true;
        //
        // let editDataList = this.listData.find(item => {
        //   return item.broadcast_id === id;
        // });
        let editDataList = item;
        // try {
        //   editDataList.broadcast_class_id = JSON.parse(
        //     editDataList.broadcast_class_id
        //   ).class_id;
        // } catch (e) {
        //   editDataList.broadcast_class_id = [editDataList.broadcast_class_id];
        // }
        this.broadcast_id = item.broadcast_id;
        let job_names = [];
        for (var i = 0; i < item.jobList.length; i++) {
          let jobName = item.jobList[i].jobc_super_name + "•" + item.jobList[i].name;
          job_names.push(jobName);
        }
        // console.log("岗位==" , job_names);
        this.form['job_names'] = job_names;
        this.form['broadcast_id'] = editDataList.broadcast_id;
        this.form['user_post'] = editDataList.user_post;
        this.form['truename'] = editDataList.truename;
        this.form['broadcast_contact'] = editDataList.broadcast_contact;
        this.form['broadcast_logo'] = editDataList.broadcast_logo;
        this.form['broadcast_name'] = editDataList.broadcast_name;
        if(editDataList.broadcast_logo
          && editDataList.broadcast_logo != '-'
          && editDataList.broadcast_logo != ''){
          this.form.broadcast_logo = editDataList.broadcast_logo;
        }else{
          this.form.broadcast_logo = this.userInfo.company_logo_url;
        }
        if (
          this.form.broadcast_logo != null &&
          !isEmpty(this.form.broadcast_logo)
        ) {
          this.imgList = [{ status: "success", url: this.form.broadcast_logo }];
        } else {
          this.imgList = [];
        }


        console.log("初始信息：" , this.userInfo);

        this.tipsPerfect();
        //this.dialogFormVisible = true;
        return;
      }
    },
    //进入直播-----------------------------------------------------
    joinData(state, id, item) {
      //state : 2 , id : 3225
      console.log("state-------", state, "id------", id, "item-------", item);

      //获取直播间是否有坐满3展商
      //axios
      if (!isInternet()) {
        return (this.downloadShow = true);
      }
      if(item) {
        if(item.is_modify == 0){
          MessageBox({
            title: "",
            message: "还没有进行布展，无法进入直播间",
            confirmButtonText: language().confirm,
            cancelButtonText: language().cancel,
            showCancelButton: false,
          }).then(() => {
            //确认
          }).catch(() => {
            //取消
          });
          return;
        }
      };

      const props = {
        broadcast_id: id
      };
      getLiveUrl(props).then(res => {
        if (res.type == 11){
          MessageBox({
            title: "",
            message: Cookie.get("lang")=='ch'?res.text:res.text_en,
            confirmButtonText: language().confirm,
            cancelButtonText: language().cancel,
            showCancelButton: false,
            // type: 'success'
          }).then(() => {
            //确认
          }).catch(() => {
            //取消
          });
        } else if (res.type != "1") {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        const data = res.data[0];
        sessionStorage.setItem('userType', res.prcurl);
        // console.log(data);
        // return;
        let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
        return (window.location.href =
          windowsGoTo() + roomUrl(data, name));
      });
      /*const props = {
        // token: this.token,
        // broadcast_id: id,
        client_id: this.$store.state.live.client_id,
      };*/
      // this.$store
      //   .dispatch("getLiveInfo", props)
      /*console.log("====client_id=====", this.$store.state.live.client_id);
      //参展商进入直播间
      exhibitionEnterLiveRoom(`/room/${id}`, props).then((res) => {
        console.log(res, "=====enterLiveRoom=====");
        if (res.data.type != 200) {
          return this.$message.error({
            message: res.data.msg,
            offset: 120,
          });
        }
        return window.open(
          windowsGoTo() + roomUrl(res.data.data, this.userInfo.true_name)
        );
      });*/
    },
    showBroadcast(e, i, flag) {
      if(flag == 1){
        let newTranslate = e.translate == 0 ? 1: 0;
        let params = {
            broadcast_id: e.broadcast_id,
            flag: flag,
            translate: newTranslate,
          };
          toggleBroadcast(params).then((data) => {
            if (data.type != 1) {
              if (this.lan == "ch") {
                const height = document.body.clientHeight / 2;
                return this.$message.error({ message: res.text, offset: height });
              } else {
                this.$message.error({ message: res.text_en, offset: 120 });
              }
              return;
            }
            this.cloneListData[i].translate = newTranslate;
          });

        return;
      }
      console.log(e, "item---展会信息列表", i, "索引----");
      var message = "";
      var paramsBroadcastShow = null;
      if (e.broadcast_show == 0) {
        var message = this.lan == "ch" ? "开启" : "Show";
        paramsBroadcastShow = 1;
      } else {
        var message = this.lan == "ch" ? "隐藏" : "Hide";
        paramsBroadcastShow = 0;
      }

      let confirmMessage =
        this.lan == "ch"
          ? "确认" + message + "直播间?"
          : "Do you confirm " + message + " your studio booth";
      let title = this.lan == "ch" ? "提示" : "info";
      let subButton = this.lan == "ch" ? "确定" : "confirm";
      let cancleButton = this.lan == "ch" ? "取消" : "cancel";
      this.$confirm(confirmMessage, title, {
        confirmButtonText: subButton,
        cancelButtonText: cancleButton,
        type: "warning",
      })
        .then(() => {
          let params = {
            broadcast_id: e.broadcast_id,
            broadcast_show: paramsBroadcastShow,
          };
          toggleBroadcast(params).then((data) => {
            if (data.type != 1) {
              if (this.lan == "ch") {
                const height = document.body.clientHeight / 2;
                return this.$message.error({ message: res.text, offset: height });
              } else {
                this.$message.error({ message: res.text_en, offset: 120 });
              }
              return;
            }
          });
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            this.$message({
              type: "success",
              message: "操作成功!",
              offset:height
            });
          } else {
            this.$message({
              type: "success",
              message: "Operation Successful!",
            });
          }          this.cloneListData[i].broadcast_show = paramsBroadcastShow;
          //  this.getList();
        })
        .catch(() => {});
    },

    // 查看联系方式
    // selectContact(e){
    //   let parmas = {
    //     token: this.token,
    //     broadcast_id: e.broadcast_id
    //   }
    //   selectContact(parmas)
    //       .then(res => {
    //           if (res.type != "1") {
    //               if (this.lan == "ch") {
    //                   return this.$message.error({ message: res.text, offset: 120 });
    //               }
    //               return this.$message.error({ message: res.text_en, offset: 120 });
    //           }
    //           this.$alert(
    //               res.data[0].broadcast_contact,
    //               this.language.hintContact,
    //               {
    //                   confirmButtonText: this.language.confirm,
    //                   callback: action => {}
    //               }
    //           );
    //       })
    //       .catch(() => {});
    // },

    //取消/关闭
    cancel() {
      this.$refs.dialogChild.receiveDialogFormVisible = false;
    },
    //确认修改
    ok() {
      let _this = this;
      this.$refs.broadcastForm.validate((valid) => {
        if(this.userJobList.length <= 0 || this.perfectMess) {
          return;
        }
        else if (valid) {
          _this.editBroadcastList();
        }
      })

    },
    //修改布展信息-----------------------
    editBroadcastList() {

      //是否布展
      // if(this.form.is_modify == 0){

      // }

      let job_ids = []
      for (let i = 0; i < this.userJobList.length; i++) {
        for (let j = 0; j < this.form.job_names.length; j++) {
          let name = this.form.job_names[j].split("•");
          console.log("子名字" , name);
          if(this.userJobList[i].name == name[1]){
            job_ids.push(this.userJobList[i].id);
            break;
          }
        }
      }
      let data = {
        lan: this.lan,
        token: this.token,
        job_ids: job_ids,
        broadcast_id: this.form.broadcast_id,
        broadcast_name: this.form.broadcast_name,
        user_post: this.form.user_post,
        truename: this.form.truename,
        broadcast_logo: this.form.broadcast_logo,
        broadcast_contact: this.form.broadcast_contact
      };
      for(let key  in data){
        if(data[key] == '-'){
          data[key] = '';
        }
      }
     // console.log(data);
     // return false;
      editBroadcastList(data)
        .then((res) => {
          if (res.type == "1") {
            const height = document.body.clientHeight / 2;
            this.$message({
              showClose: true,
              message: this.language.editSuccess,
              type: "success",
              offset: height,
            });
            this.$refs.dialogChild.receiveDialogFormVisible = false;

            this.currentPage = 1;
            this.getList();
            let paramsData = {
              exh_user_id: this.form.exh_user_id,
              exhibition_id: this.form.exhibition_id,
            };
            // if(this.lan == 'ch'){
            //   this.showImg(paramsData);
            // }
          } else {
            if (this.lan == "ch") {
              const height = document.body.clientHeight / 2;
              return this.$message.error({ message: res.text, offset: height });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
        })
        .catch(() => {});
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.getList();
    },
    //点击展会标题--------------------
    exhChange(exhId) {
      if(exhId == ''){
        this.$refs.serarchBar.clear();
      }else{
        this.currentPage = 1;
        this.exhibition_id = exhId;
        this.getList();
      }


    },

    //搜索切换
    toSearch(state, val, keyword) {
      // console.log("信息：===" + state + " " + val + " " + keyword);
      this.getStateCon = state;
      this.getJobId = val;
      this.keyword = keyword;
      this.currentPage = 1;
      //获取展览列表------------------------------------------------------
      // this.getExhibition().then((res) => {
      //   let exh_list = res.data;
      //   exh_list.push({
      //     exh_name: "全部",
      //     exh_name_en: "ALL",
      //     exh_state: "",
      //     exhibition_id: ""
      //   });
      //   this.exh_list = exh_list;
      //   this.exhibition_id = "";
      //   this.getList();
      // });
      this.getList();
    },
    //获取直播间分类
    broadcastClass() {
      if(this.userInfo.superioruser_id != 0) {
        this.userId = this.userInfo.superioruser_id;
      }else {
        this.userId = this.userInfo.user_id;
      }
      findUserJogList({ user_id: this.userId }).then((res) => {
        if (res.type == "1") {
          this.userJobList = res.data;
          // console.log("招聘岗位== " , this.userJobList);
        }
      //  this.form.broadcast_class_id = data[0].broadcast_class_id;
      });
    },
    //下载谷歌浏览器
    download() {
      window.open(
        "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    },
    //布展流程
    boothProcess(){
      this.showBoothProcess = true;
    },
    changeTime(time) {
      var newdate = new Date(time);
      var YY = newdate.getFullYear();
      var MM =
        (newdate.getMonth() + 1).toString().length == 1
          ? "0" + (newdate.getMonth() + 1)
          : newdate.getMonth() + 1;
      var DD =
        newdate.getDate().toString().length == 1
          ? "0" + newdate.getDate()
          : newdate.getDate();
      var hh =
        newdate.getHours().toString().length == 1
          ? "0" + newdate.getHours()
          : newdate.getHours();
      var mm =
        newdate.getMinutes().toString().length == 1
          ? "0" + newdate.getMinutes()
          : newdate.getMinutes();
      var ss =
        newdate.getSeconds().toString().length == 1
          ? "0" + newdate.getSeconds()
          : newdate.getSeconds();

      return YY + "-" + MM + "-" + DD + " " + hh + ":" + mm + ":" + ss;
    },

    getList() {
      let that = this;
      this.loading = true;
      this.listData = [];
      let data = {
        exhibitionState: this.getStateCon,
        keyword: this.keyword,
        currentPage: this.currentPage,
        numberPage: this.pageSize,
        user_id: this.userInfo.user_id,
        lan: this.lan,
        exhibition_id:this.getJobId
      };
      //当前用户在展会下的直接间
      getMyBroadcastList(data).then((resp) => {
        let res = resp;
        if (res.type == 1) {
          if (!res.data) {
            this.listData = [];
            this.cloneListData = [];
            this.pageTotal = res.datacount * 1;
            this.loading = false;
            return false;
          }

          res.data.forEach((item) => {

            //遍历字段若字段取值为null则默认显示-
            for(let key in item){
              if( item[key] == null ||  item[key] == 'null'){
                item[key] = '';
              }
            }
            item.periodTime =
              this.language.CreateTime +
              ": " +
              this.changeTime(item.truetime * 1000);
            // console.log(item.truetime)
            // console.log(item.periodTime)
            if (item.broadcast_type == 1) {
              if (this.lan == "en") {
                var broadcast_type_name = "1V1";
              } else {
                var broadcast_type_name = "一对一";
              }
            }
            /*if (item.broadcast_type == 2) {
              if (this.lan == "en") {
                var broadcast_type_name = "Fourm";
              } else {
                var broadcast_type_name = "论坛";
              }
            }*/

            item.broadcast_type_name = broadcast_type_name;
          });

          this.listData = res.data;
          this.loading = false;
          this.cloneListData = res.data;
          this.pageTotal = res.datacount * 1;
          // console.log("直播间" , res.data)
          this.tipJob = "";
          //this.getContentWrapHeight();
        } else {
          const height = document.body.clientHeight / 2;
          that.$message.error({
            message: res.text,
            offset: height,
          });
        }
      });
    },
    //手机海报分享----------------------------------
    showImg(e) {

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        exhibition_id: e.exhibition_id,
        broadcast_id: e.user_id,
        currentTab: "1",
      };
     reqest.send(reqest.adminapi+"MakeQr/getExhibitionRr", data)
        .then((res) => {
          loading.close();
          if (res.type == "1") {
            this.imgSrcList = res.data.img;
            this.showImgDialogFormVisible = true;
          } else {
            if (this.lan == "ch") {
              const height = document.body.clientHeight / 2;
              return this.$message.error({ message: res.text, offset: height });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    changeImgSrc(index) {
      this.imgSrcIndex = index;
    },

    // 跨域文件下载
    downloadIamge(url, fileName) {
      url = url.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      xhr.onload = () => {
        if (xhr.status == 200) {
          let data = xhr.response;
          let name = fileName;

          var urlObject = window.URL || window.webkitURL || window;
          var export_blob = new Blob([data]);
          var save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
          );
          save_link.href = urlObject.createObjectURL(export_blob);
          save_link.download = name;
          save_link.click();
        }
      };

      xhr.send();
    },
    imgDown() {
      // this.downloadIamge(this.imgSrcList[this.imgSrcIndex], 'pic.jpg')
      location.href =
        reqest.apiUrl+"/Home/Pub/downloadfile?file_path=" +
        this.imgSrcList[this.imgSrcIndex];
    },

    cancelImg() {
      this.showImgDialogFormVisible = false;
    },
  },
};
</script>
<style scoped>
  .broadcast_logo{
    width: 85px;
    height: 85px;
    background-color: #f2f2f2;
    border: solid 1px #2b6ff9;
    border-radius: 50%;
  }
  .submitBtn{
    width: 183px!important;
    height: 56px!important;
    line-height: 56px!important;
    background-color: #f47900;
    border-radius: 4px;
    padding: 0px;
    font-size: 20px!important;
  }
  .cancelBtn{
    width: 183px!important;
    height: 56px!important;
    line-height: 56px!important;
    background-color: #eff0f1;
    border-radius: 4px;
    padding: 0px;
    margin-left: 25px;
    font-size: 20px!important;
  }
  .edit-job{
    font-size: 14px;
    color: #2b6ff9;
    padding-right: 10px;
    cursor: pointer;
  }
</style>
<style>
.broadcastoto .page {
  margin-left: 0;
}
.broadcastoto .otoCon {
  padding-bottom: 30px;
}
.seatManagement .el-dialog__body{
  padding: 0px 0px!important;
}
.seatManagement .el-dialog {
  border-radius: 10px;
  padding: 5px;
}
.place-manage {
  width: 1068px;
  height: 24px;
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  line-height: 6px;
  letter-spacing: 0px;
  color: #333333;
  text-align: left;
  margin-left: 20px;
  padding-left: 0px !important;
  border-bottom: 1px solid #CCCCCC;
}
.seatManagement .el-dialog__header {
  height: 20px;
}
.seatManagement .el-dialog__close {
  width: 22px;
  height: 22px;
  background-color: #2b6ff9;
  border-radius: 50%;
}
.bz span{
  color: #FFFFFF !important;
}
.boothProcessTitle{
  font-size: 14px;
  line-height: 48px;
  color: #ee720c;
  text-align: left;
}
.boothProcessContent{
  height: 70vh;
  overflow-y: auto;
}
.boothProcessContent img{
  display: block;
  width: 100%;
  height: auto;
}
.footerBottom {
  padding-top: -2px !important;
}
.dislogCon .el-dialog__header {
  position: relative;
  height: 60px !important;
  text-align: left;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 6px;
  letter-spacing: 0px;
  color: #333333;
}
.dislogCon .el-dialog__header .el-dialog__title {
  font-size: 24px;
  position: relative;
  top: 20px;
  font-family: SourceHanSansCN-Bold;
}
.dislogCon .el-input__inner{
  background-color: #eff0f1;
  border: 0px;
}
.dislogCon .el-dialog__headerbtn {
  top: 9px;
  right: 0;
  width: 22px;
  height: 22px;
  background-color: #2b6ff9;
  border-radius: 11px;
}
.el-dialog__headerbtn .el-dialog__close{
  color: #FFFFFF !important;
}
.broadcast-edit-form .el-form-item__error{
  left: 22px;
}
.dislogCon .broadcast-edit-form .el-form-item__label{
  text-align: right;
  margin-right: 10px;
}
.dislogCon .broadcast-edit-form .el-form-item__content{
  text-align: left;
  margin-left: 105px !important;
}
.seatManagementContent{
  position: relative;
  overflow: hidden;
  padding: 10px 10px;
  background: #FFFFFF;
}
</style>

<style scoped>
.companyIntro {
  width: 626px;
  display: block;
  overflow: hidden;
  margin-left: 12px;
  margin-bottom: 20px;
}
.companyIntro .left {
  float: left;
}
.companyIntro .right {
  margin-left: 100px;
}
.wanShanXX {
  width: 560px;
  height: 50px;
  position: relative;
  left: -20px;
  background-color: rgb(255,0,0,0.1);
  color: #ff0000;
  font-size: 18px;
  text-align: left;
  padding-left: 40px;
  line-height: 50px;
  margin-bottom: 10px;
}
.no-job {
  width: 560px;
  height: 50px;
  position: relative;
  left: -124px;
  top:36px;
  background-color: rgb(255,0,0,0.1);
  color: #ff0000;
  font-size: 18px;
  text-align: left;
  padding-left: 40px;
  line-height: 50px;
  margin-bottom: 40px;
}
.job {
  margin-bottom: 20px;
}
.broadcastoto >>> .prompt-info-wrap {
  padding: 20px 10px 27px 20px;
  background: #fff;
  margin-top: 10px;
  border-radius: 5px;
}
.broadcastoto >>> .prompt-info {
  height: 30px;
  line-height: 30px;
  background: #fff;
  color: #f47900;
  font-size: 18px;
  font-weight: bold;
}
.prompt-info span {
  color: #0071ff;
  cursor: pointer;
}
.dislogCon {
  text-align: center;
}
.dislogCon .el-dialog {
  width: 600px;
}
.img-formBtn {
  /* margin: 0 auto;
  text-align: center; */
  text-align: right;
  margin-top: 30px;
  margin-right: 20px;
}
.img-down-formBtn {
  background: #ff9e00;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}
.img-camcale-formBtn {
  background: #cccccc;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}

.img-wrap {
  width: 100%;
  padding: 20px 0;
  display: flex;
}
.img-wrap-left {
  flex: 1;
  padding: 20px;
  border-radius: 20px;
  min-height: 500px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ececec;
}
.choose-img {
  width: 300px;
  text-align: center;
  margin: 0 auto;
}
.img-wrap-right {
  flex: 2.5;
  margin: 0 auto;
  padding-top: 20px;
}
.img-wrap-right-top {
  display: inline-block;
  margin-top: 20px;
}
.img-wrap-right-top img {
  width: 150px;
}
.img-wrap-right-top-div {
  /* display: inline-block; */
  float: left;
  height: 290px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #ececec;
  margin: 0 10px;
  position: relative;
}
/* .img-right{
    display: none;
} */
.img-right {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0 !important;
  width: 30px !important;
  height: 30px;
}
.img-wrap-right-top-div img {
  padding: 20px 10px;
}
.img-wrap-right-top-div-active {
  border: 3px solid #ff9e00;
}
.img-wrap-title {
  width: 150px;
  margin: 0 auto;
  position: relative;
  z-index: 9;
}
.img-wrap-title p {
  color: #212c67;
  font-size: 1.3rem;
  z-index: 9;
}

.div-border-bottom-color {
  width: 150px;
  height: 3px;
  background: #c7d0f2;
  position: absolute;
  left: 0;
  bottom: 1px;
  z-index: -1;
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>
